let AlbumCategory = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
        this.sort();
    },

    delete: function () {
        $('.delete-album-category').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/albums/categories/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const albumCategoryForm = $('#albumCategoryForm');

        if (albumCategoryForm.length) {
            let submitBtn = Ladda.create(albumCategoryForm.find('[type=submit]')[0]);

            albumCategoryForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/albums/categories/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        $('#albumCategories').on('draw.dt', function () {
            _this.delete();
        });
    },

    sort() {
        const table = $('#albumCategories');
        table.sortable({
            items: 'tbody tr',
            stop: function (e, ui) {
                let order = [];
                const rows = ui.item.closest('table').find('tbody tr');

                rows.each((key, row) => {
                    order.push($(row).data('id'));
                });

                console.log(order);

                $.post('/albums/categories/reorder', {
                    order
                }, response => {
                });
            }
        });
    },
};

$().ready(function () {
    window.AlbumCategory = AlbumCategory;
    window.AlbumCategory.init();
    
    let table = $('#albumCategories').DataTable();
    $("div.toolbar").html('<div>'+$('.radioDiv').html()+'</div>');
    $('.radioDiv').remove();
    $(".fill").addClass("fs");
    $('.fs').change(function () {
        table.columns(4).search(this.value).draw();
    });
});
